var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoIconLarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 48,
    fill: "#D4F4FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.2 39.6H50.8V34H45.2V39.6ZM48 70.4C35.652 70.4 25.6 60.348 25.6 48C25.6 35.652 35.652 25.6 48 25.6C60.348 25.6 70.4 35.652 70.4 48C70.4 60.348 60.348 70.4 48 70.4ZM48 20C32.544 20 20 32.544 20 48C20 63.456 32.544 76 48 76C63.456 76 76 63.456 76 48C76 32.544 63.456 20 48 20ZM45.2 62H50.8V45.2H45.2V62Z",
    fill: "#002CB1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconLarge);
export default __webpack_public_path__ + "static/media/InfoIconLarge.2b83e4dbccd34fd421a7bf563ff550d5.svg";
export { ForwardRef as ReactComponent };